
export interface DefaultSettings {
    primaryColor: string;
    title: string;
    iconfontUrl: string;
}

export default {
  primaryColor: 'daybreak',
  title: '',
  iconfontUrl: '//at.alicdn.com/t/font_1548148_13afoy1z8wn.js',
} as DefaultSettings;
